module.exports = __webpack_public_path__ + "static/meta-image-0607cc68f64e5cd17f2daa1c2c5102c7.png";